import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { CodeActionType, ReadOnlyType } from 'app/area/codetable/item/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { configurationAlreadyExistsKey } from 'app/area/indicator-factors/constants';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const UomTypeTo = (props: ScreenPickerProps) => {

  const { breadcrumbs, codeItem, updateByKey, resetValidation, codetableOptions, loadCodetableOptions,
    translation, validation, readOnlyConfig, actionType } = props;

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.uomTypeTo);
    ((isDefinedIncludingZero(codeItem?.uomTypeFrom?.value) && codeItem?.uomTypeTo?.value !== value?.value &&
      codeItem?.uomTypeFrom?.value === codeItem?.uomTypeTo?.value) || validation[configurationAlreadyExistsKey])
      && resetValidation(ScreenPicker.uomTypeFrom);
    updateByKey(ScreenPicker.uomTypeTo, value);
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableOptionsIds.uomTypeTo, loadOptionsParams);
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableOptionsIds.uomTypeTo, breadcrumbs);

  const codeOptions = (codetableOptions?.[ScreenPicker.uomTypeTo]?.codes || []) as CodeComplexValue<number>[];

  const uomTypeToValidation = !!validation?.[ScreenPicker.uomTypeTo] ? validation[ScreenPicker.uomTypeTo] : undefined;

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all] || actionType === CodeActionType.Edit;

  return <CodeSinglePicker
    id={ScreenPicker.uomTypeTo}
    label={translation.uom_type_to}
    valueItem={codeItem && codeItem.uomTypeTo}
    searchRequired={false}
    required={!readOnly}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions?.[ScreenPicker.uomTypeTo]?.fetching}
    extraFooterButton={extraFooterButton}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={uomTypeToValidation}
  />;
};
